// extracted by mini-css-extract-plugin
module.exports = {"root":"ManageRoles_root__3fUgs","tableControls":"ManageRoles_tableControls__DhTOu","search":"ManageRoles_search__2rSsq","checkbox":"ManageRoles_checkbox__1G80m"};